interface iContentCardLoadingItemProps {
  y: number;
  isMobile?: boolean;
}

function ContentCardLoadingItem({
  y,
  isMobile = false,
}: iContentCardLoadingItemProps) {
  if (isMobile) {
    return <rect x='0' y={y} rx='8' ry='8' width={1000} height='150' />;
  }

  return <rect x='0' y={y} rx='8' ry='8' width={1000} height='80' />;
}

export { ContentCardLoadingItem };
